// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"c9e09035bd7c42bdd225","678":"e53ef48a6409ad6d0dd3","713":"667726cb7b6dadbdbc1e","883":"3ce4de09c73c310f59f8"}[chunkId] + ".js";
};